/* eslint-disable */
import book_hold_inventory from "@/apollo/flights/bookings/reports/book_hold_inventory.gql";

export const state = () => ({});

export const mutations = {};

export const actions = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 10 Jan 2024 | 10:52AM
   * @param {*} __
   * @param {*} payload
   * @returns {*}
   */
  bookHoldInventory(__, payload) {
    return new Promise(async (resolve) => {
      const {
        data: { flt_book_hold_inventory }
      } = await this.$apolloClient.mutate({ mutation: book_hold_inventory, variables: { payload } });
      resolve(flt_book_hold_inventory);
    });
  }
};

export const getters = {};
